import React from 'react';
import { IM110FormsModule } from '~/lib/data-contract';
import M110FormsModule from './m110-forms-module';

export const M110FormsModuleBlock = (props: IM110FormsModule) => {
    return <M110FormsModule {...props} />;
};
